import {styled} from '@linaria/react';
import React from 'react';
import {COLORS} from '../../../constants/colors';
import {mobileOnlyLinaria} from '../../../constants/customMedia';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';

export const LowestProductPrice30D: React.FC<{
  label: string;
  className?: string;
}> = ({label, className}) => {
  return (
    <Wrapper data-testid="lowestProductPrice30D" className={className}>
      {label}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  text-align: center;
  width: 100%;
  font-size: ${FONT_SIZES.px10};
  line-height: ${FONT_SIZES.px16};
  color: ${COLORS.Grey1};

  ${mobileOnlyLinaria(`
    font-weight: ${FONT_WEIGHTS.mediumBold};
  `)}
`;
